import { apiFetch } from './client.js';
import type { ProjectCatalog } from '@supernova/shared';

export type { ProjectCatalog };

export async function getProjectCatalogs(projectId: string): Promise<ProjectCatalog[]> {
  const data = await apiFetch<{ projectCatalogs: ProjectCatalog[] }>(
    `/api/v1/projects/${projectId}/catalogs`,
  );
  return data.projectCatalogs;
}

/** catalogIds en orden de prioridad (índice 0 = mayor prioridad). */
export async function setProjectCatalogs(
  projectId: string,
  catalogIds: string[],
): Promise<ProjectCatalog[]> {
  const data = await apiFetch<{ projectCatalogs: ProjectCatalog[] }>(
    `/api/v1/projects/${projectId}/catalogs`,
    { method: 'PUT', body: { catalogIds } },
  );
  return data.projectCatalogs;
}
